export const USER_RESET = "USER_RESET" as const;
export const USER_SET = "USER_SET" as const;
export const USER_NOTIFICATION_SETTINGS_SET = "USER_NOTIFICATION_SETTINGS_SET" as const;
export const USER_LOGIN_SET = "USER_LOGIN_SET" as const;
export const USER_INDUSTRY_SET = "USER_INDUSTRY_SET" as const;
export const USER_SESSION_SET = "USER_SESSION_SET" as const;
